import { IRPF_CONFIG } from "../config/irpfConfig";
import { formatCurrency } from "../config/irpfConfig";

const clampNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getEducationDeductionLimit = (dependents = 0) =>
  IRPF_CONFIG.deductions.educationLimitPerPerson * (clampNumber(dependents) + 1);

const getAppliedBracket = (baseCalculation) => {
  return (
    IRPF_CONFIG.annualBrackets.find(
      (bracket) => baseCalculation <= (bracket.upTo ?? Number.POSITIVE_INFINITY)
    ) ?? IRPF_CONFIG.annualBrackets[IRPF_CONFIG.annualBrackets.length - 1]
  );
};

export const calculateIrpf = ({
  income,
  deductionModel,
  socialSecurity,
  dependents,
  education,
  medicalExpenses,
  alimony,
  otherDeductions,
  withheldTax,
}) => {
  const safeIncome = clampNumber(income);
  const safeDependents = clampNumber(dependents);
  const safeEducation = Math.min(
    clampNumber(education),
    getEducationDeductionLimit(safeDependents)
  );

  const itemizedDeductions =
    clampNumber(socialSecurity) +
    safeDependents * IRPF_CONFIG.deductions.dependentDeduction +
    safeEducation +
    clampNumber(medicalExpenses) +
    clampNumber(alimony) +
    clampNumber(otherDeductions);

  const simplifiedDeductions = Math.min(
    safeIncome * IRPF_CONFIG.deductions.simplifiedRate,
    IRPF_CONFIG.deductions.simplifiedDeductionLimit
  );

  const deductions =
    deductionModel === "completa" ? itemizedDeductions : simplifiedDeductions;

  const baseCalculation = Math.max(0, safeIncome - deductions);
  const bracket = getAppliedBracket(baseCalculation);
  const totalTax = Math.max(
    0,
    baseCalculation * (bracket.rate / 100) - bracket.deduction
  );
  const totalDue = totalTax - clampNumber(withheldTax);

  return {
    deductions,
    baseCalculation,
    bracket,
    totalTax,
    totalDue,
    educationInput: safeEducation,
    formatted: {
      deductions: formatCurrency(deductions),
      baseCalculation: formatCurrency(baseCalculation),
      totalTax: formatCurrency(totalTax),
      totalDue: formatCurrency(Math.abs(totalDue)),
      deductionValue: formatCurrency(bracket.deduction),
      withheldTax: formatCurrency(clampNumber(withheldTax)),
    },
  };
};
